import Select from "react-select";
import "./Selector.css";

const dropdownStyle = {
  option: (provided, state) => ({
    ...provided,
    //borderBottom: "1px dashed #008c45",
    backgroundColor: state.isDisabled
      ? undefined
      : state.isSelected
      ? "#F8DB66"
      : state.isFocused
      ? "#c9c9c9"
      : undefined,
    color: state.isDisabled
      ? undefined
      : state.isSelected
      ? "black"
      : state.isFocused
      ? "black"
      : undefined,
    fontStyle: state.isSelected ? "italic" : undefined,
    fontWeight: state.isSelected ? "bold" : undefined,
    paddingLeft: "30px",
    textAlign: "center",
    //padding: 20,
    //padding: 20,
    cursor: "pointer",
  }),
  control: (provided) => ({
    ...provided,
    //width: 200,
    height: 40,
    boxShadow: "0px 3px 5px #a7a7a7",
    // backgroundColor: "transparent",
    color: "#808080",
    // color: "#fff",
    paddingLeft: "20px",
    cursor: "pointer",
    // borderRadius: "20px",
    borderStyle: "none",
    border: "2px",
    borderColor: "#008c45",
    "&:hover": {
      borderStyle: "solid",
      borderColor: "#008c45",
      color: "red",
    },
    "@media (max-width: 600px)": {
      paddingLeft: "0px",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    //const opacity = state.isDisabled ? 0.5 : 1;
    //const transition = "opacity 300ms";
    // color: "white",

    //return { ...provided, opacity, transition };
  }),
  menu: (provided, state) => ({
    ...provided,
    color: "#808080",
    // color: "#fff",
    // paddingTop: "15px",
  }),
};

export default function Selector({
  callback,
  label,
  placeholder,
  options,
  defaultValue,
  isDisabled = false,
  isLoading = false,
  isClearable = true,
  isSearchable = true,
}) {
  return (
    <div className="selector-container">
      <p className="selector-label">{label}</p>
      <Select
        name="Unidades"
        classNamePrefix="select"
        //className="basic-single"
        styles={dropdownStyle}
        //
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        isRtl={false}
        isSearchable={isSearchable}
        //
        placeholder={placeholder}
        defaultValue={defaultValue}
        options={options}
        // onChange={(option) => callback(option ? option.value : null)}
        onChange={(option) => callback(option)}
      />
    </div>
  );
}
